
<template>
  <div>
    <div v-if="questions.length === 0" class="ui vertical segment">
      <span>Keine Nachrichten in dieser Liste ...</span>
    </div>

    <QuestionsListItem v-for="item in questions" :data="item" :key="item.id" ></QuestionsListItem>
  </div>
</template>

<script>
  import QuestionsListItem from './QuestionsListItem'

  export default {
    name: 'QuestionsList',
    components: {
      QuestionsListItem
    },
    props: { 
      questions: Array,
    }
    
  }
</script>

<style scoped>
</style>